import { getColumnTransactions } from 'constants/table';
import { Table } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useGetAllPayments } from 'hooks/useGetPayments';
import { PAGE_SIZE_TRANSACTION } from 'services/api/module/report.api';
import { usePaymentStateOptions } from 'constants/form';
import { usePaymentMethodOptions } from 'hooks/usePaymentMethodOptions';

interface TransactionV1Props {
  filterOptions: any;
  setSelectedPaymentState: (state: string | undefined) => void;
  setSelectedPaymentMethod: (method: string | undefined) => void;
  t: (key: string) => string;
}

export function TransactionV1(props: TransactionV1Props) {
  const { filterOptions, setSelectedPaymentState, setSelectedPaymentMethod, t } = props;
  const { paymentMethodFilterOptions } = usePaymentMethodOptions(t);
  const { paymentMethodNames } = usePaymentMethodOptions(t);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE_TRANSACTION);
  const paymentStateOptions = usePaymentStateOptions(t);

  const handleChangePage = (page: number) => {
    setPage(page);
  };
  const {
    data: dataSource,
    pagination,
    isFetching
  } = useGetAllPayments(filterOptions, page, pageSize);

  const selectedPaymentState = paymentStateOptions.find(
    option => option.value === filterOptions.state
  );

  const selectedPaymentMethod = paymentMethodFilterOptions.find(
    option => option.value === filterOptions.payment_method
  );

  useEffect(() => {
    if (selectedPaymentState) {
      setSelectedPaymentState(selectedPaymentState?.label);
    }
    if (selectedPaymentMethod) {
      setSelectedPaymentMethod(selectedPaymentMethod?.label);
    }
    // eslint-disable-next-line
  }, [dataSource, selectedPaymentMethod, selectedPaymentState]);

  const columnTransactions = useMemo(() => {
    return getColumnTransactions(t, paymentMethodNames);
  }, [t, paymentMethodNames]);

  return (
    <div>
      <Table
        loading={isFetching}
        rowKey="id"
        columns={columnTransactions}
        dataSource={dataSource}
        pagination={{
          current: page,
          position: ['bottomCenter'],
          total: pagination.total,
          pageSize: pageSize,
          locale: { items_per_page: `/ ${t('common.page')}` },
          showTotal: total => `${total} ${t('common.item')}`,
          onChange: (page: number) => handleChangePage(page),
          onShowSizeChange: (current, size) => {
            setPageSize(size);
          }
        }}
        locale={{
          emptyText: <span className="empty-data">{t('common.actions.noData')}</span>
        }}
        scroll={{ x: 1400, y: 'calc(100vh - 400px)' }}
      />
    </div>
  );
}
